import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { trackById } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-chart-header",
    templateUrl: "chartHeader.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["chartHeader.component.scss"],
})
export class ChartHeaderComponent implements OnInit, OnDestroy {
    @Input() itemId: string;
    @Input() iconClass: string;
    @Input() items: any[];
    @Input() label: string;
    @Output() selectionChanged = new EventEmitter<string>();
    @Input() selectedCategory: any;
    coIdFromUrl: number;
    @Input() isCollapsed: boolean = true;
    private destroy$ = new Subject<void>();

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.coIdFromUrl = params["coId"];
        });
        this.selectedCategory = this.items.find(
            (item) => item.id == this.coIdFromUrl,
        );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    selectCategory(item) {
        this.selectedCategory = item;
        this.selectionChanged.emit(item.id);
    }

    public trackById = trackById;
}
